import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'

import Axios from '@components/Axios'
import Icon from '@components/Icon'
import Table from '@components/Table'

import './styles.scss'

const MethodologyList = ({ list = [], setItem, updateList }) => {
  const columns = [
    { title: 'METHODOLOGY_LIST_TITLE', field: 'title' },
    { title: 'METHODOLOGY_LIST_URL', field: 'archive' },
    { title: 'METHODOLOGY_LIST_DATE', field: 'date'},
    { title: 'POST_LIST_PUBLISH',
      component: item => {
        let status = item.status === 'PUBLISHED' ? 'Publicado' : 'Rascunho'
        return (
          <>
            {status}
          </>
        )
      }
    },
    {
      title: 'VIDEO_LIST_OPTIONS',
      className: 'options',
      component: item => {
        return (
          <>
            <IconButton onClick={() => setItem(item)} className="list-edit">
              <Icon size={30} name="edit" />
            </IconButton>
            <Axios
              api="methodologys"
              method="delete"
              others={item._id}
              onSuccess={updateList}
            >
              {({ submit }) => (
                <IconButton onClick={submit} className="list-delete">
                  <Icon size={30} name="delete_icon" />
                </IconButton>
              )}
            </Axios>
          </>
        )
      }
    }
  ]

  return (
    <div className="MethodologyList">
      <Table data={list} columns={columns} title="METHODOLOGY_LIST_TABLE_TITLE" />
    </div>
  )
}

export default MethodologyList

MethodologyList.propTypes = {
  list: PropTypes.array,
  setItem: PropTypes.func,
  updateList: PropTypes.func
}
